export const containerClassName = 'flex flex-col min-h-full'

export const commonClassNameForLoadingFailureNoDataView = '!h-[326px]'

export const noDataViewClassName = `${commonClassNameForLoadingFailureNoDataView} !mb-0`

export const searchResultsListContainerClassName =
   'px-[8px] h-full w-full overflow-y-auto'

export const infiniteLoadingViewContainerClassName =
   'flex justify-center h-40px'

export const resultsHeadingClassName = 'text-sm-medium ml-18px mb-4px'

export const itemContainerClassName =
   'flex items-center justify-between cursor-pointer px-16px py-12px mb-4px rounded-xl'

export const pipelineAndFieldsSelectionContainerClassName =
   'flex ml-16px mb-16px'

export const pipeClassName = 'w-[1px] h-[24px] ml-[8px] rounded-md'
